import { FieldLabel, Flex, FlexBox, Input, InputGroup } from "@braze/beacon-core";
import { useState } from "react";
import styled from "styled-components";
import { FormContainer } from "./FormContainer";
import { FieldProps } from "./types";

interface RequiredTextProps extends FieldProps {
    info? : string;
    warningText? : string;
    maxLength? : number;
}
export const RequiredText = (props : RequiredTextProps) => {

    const [invalid, setInvalid] = useState(true);

    return (
        // <TextFlex>
        //     <FieldLabel label={props.name}>
        //         <Input fullWidth placeholder={props.info}
        //             onChange={(e) => {
        //                 if (!e.target.value) {
        //                     props.handleChange(e.target.value);
        //                 }
        //                 else {
        //                     props.handleChange(e.target.value);
        //                 }
        //             }}
        //         />
                    
        //     </FieldLabel>
        // </TextFlex>
        <FormContainer>
            <FieldLabel label={props.name} status={invalid ? "danger":"success"} statusText={props.name+" is required"} 
                infoIconPopoverContent={props.info !== null ? props.info : ""}>
                <Input name={props.name} invalid={invalid} fullWidth 
                maxLength={props.maxLength}
                onChange={(e) => {
                    if (!e.target.value) {
                        props.handleChange(e.target.value);
                        setInvalid(true);}
                    else {
                        setInvalid(false);
                        props.handleChange(e.target.value);
                    }
                }}/>
            </FieldLabel>
        </FormContainer>
        
    )
}

const TextFlex = styled(FlexBox)`
    width: 100%;
    display: flex;
    flex-direction: column;

`